/**
 *
 * @param {Object} data Data object from api
 * @param {string} language Language: "es" or "en"
 * @param {boolean} isPlural Determines if tense is plural for labels
 * @returns Array holding the series for line charts with data divided by Sentiment
 */
export const makeSeries = (data, language, isPlural) => {
  const seriesArray = [];

  const keys = Object.keys(data.data);

  keys.forEach((attribute) => {
    let lineName;
    switch (attribute) {
      case "positive":
        lineName =
          language === "en" ? "Positive" : isPlural ? "Positivos" : "Positivo";
        break;
      case "xeno":
        lineName =
          language === "en"
            ? "Xenophobic"
            : isPlural
            ? "Xenófobos"
            : "Xenófobo";
        break;
      case "neutral":
        lineName = "Neutral";
        break;
      default:
        break;
    }

    seriesArray.push({
      name: lineName,
      type: "line",
      lineStyle: {
        width: 3,
      },
      data: data.data[attribute],
    });
  });

  return seriesArray;
};
